import { FilterType, Filter, FilterKey, CourseLevelOfferStatus } from 'types';
import { IGetFilterGroupsProps } from '../../types';
import { hasPerm, P } from '@/utilities/roles/permissions';
import { UserRole } from '@/store/auth/types';

const CourseLevelOfferStatusOptions = [
  {
    label: 'Conditional',
    value: CourseLevelOfferStatus.CONDITIONAL,
  },
  {
    label: 'Unconditional',
    value: CourseLevelOfferStatus.UNCONDITIONAL,
  },
  {
    label: 'Removed',
    value: CourseLevelOfferStatus.REMOVED,
  },
  {
    label: 'Declined',
    value: CourseLevelOfferStatus.DECLINED,
  },
];

const key = FilterKey.COURSE_CONDITIONAL_STATUS;
export const getCourseConditionalStatusFilter = ({ activeFilters, userRole }: IGetFilterGroupsProps): Filter | null => {
  const canFilterConditionalStatus = hasPerm(userRole || UserRole.Unknown, P.FILTER_COURSE_CONDITION_STATUS);
  if (!canFilterConditionalStatus) {
    return null;
  }

  const filters = activeFilters[key] ?? [];
  const options = CourseLevelOfferStatusOptions.map(({ label, value }) => {
    return {
      label,
      value,
      checked: filters.some(filter => filter === value),
    };
  });
  return {
    name: 'Course conditional status',
    key,
    type: FilterType.SELECT_MANY,
    showSearch: false,
    options: {
      SELECT_MANY: options,
    },
  };
};
